export type CreateElementChild = Node | string;

export function createElement<TagName extends keyof HTMLElementTagNameMap>(
  tagName: TagName,
  attributes?: {
    [key: string]: unknown;
    children?: CreateElementChild | CreateElementChild[];
  },
) {
  const element = document.createElement(tagName);
  const { children, ...elementAttributes } = attributes ?? {};

  for (const elementAttribute in elementAttributes) {
    const attribute = elementAttribute;
    const value = elementAttributes[attribute];

    if (value != null) {
      (element as Record<string, unknown>)[attribute] = value;
    }
  }

  if (Array.isArray(children)) {
    if (children.length) {
      element.append(...children);
    }
  } else if (children) {
    element.append(children);
  }

  return element;
}
